import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { NotificacionDto } from '../../domain/notifications/notification.dto';
import { NotificationsApi } from '../api/notifications.api';

@Injectable({ providedIn: 'root' })
export class NotificationsRepository {
  private readonly notificationsApi = inject(NotificationsApi);

  list(): Observable<NotificacionDto[]> {
    return this.notificationsApi.list();
  }

  unreadCount(): Observable<{ noLeidas: number }> {
    return this.notificationsApi.unreadCount();
  }

  markRead(id: string): Observable<void> {
    return this.notificationsApi.markRead(id);
  }
}
